
export const categoryNameForNotAssignedFormats = 'NOT ASSIGNED';
